import BreadCrumbs from '@components/BreadCrumbs'
import BreadCrumbsProvider from '@components/BreadCrumbs/State/state'
import { CART_STATE_KEY } from '@components/cart/State/state'
import { IntegratedHeader } from '@components/common/Header/IntegratedHeader'
import { IntegratedHeaderPreloaded } from '@components/common/Header/IntegratedHeaderPreloaded'
import { Subscription } from '@components/common/Subscription'
import { CwsGrid, CwsGridCol, CwsGridRow, CwsSection, CwsH2, CwsDivider } from '@components/cws'
import { AppStateTypes } from '@context/reducer'
import { useAppState } from '@context/state'
import { useSso } from '@hooks/useSso'
import TranslationsLoaderProvider from '@ui/components/TranslationLoader/TranslationsLoader'
import { nicerLog } from '@utils/console-utils'
import { localStorageHelper } from '@utils/localStorageHelper'
import { useRouter } from 'next/router'
import { FC, PropsWithChildren, useState } from 'react'
import { useEffect } from 'react'
import FooterComponent from '../Footer/Footer'
import clsx from 'clsx'
import s from './Layout.module.scss'
import { isPrintMode } from '@utils/is-print-mode'

export const Layout: FC<PropsWithChildren> = (props) => {
  const { children } = props
  const { events, pathname } = useRouter()
  const [isClient, setIsClient] = useState(false)
  useSso()

  useEffect(() => {
    setIsClient(true)
  }, [])

  const {
    dispatch,
    state: { topOffset, productsListId },
  } = useAppState()

  const {
    state: { customer },
  } = useAppState()

  useEffect(() => {
    if (pathname === '/cart') return
    localStorageHelper.remove(CART_STATE_KEY)
  }, [])
  useEffect(() => {
    const handle: (p: string) => void = (fullPath) => {
      if (fullPath.includes('/collection/') || fullPath.includes('/products/') || fullPath.includes('/category/')) {
        dispatch({ type: AppStateTypes.setListId, payload: fullPath })

        if (topOffset > 0 && productsListId === fullPath) {
          nicerLog(`Scrolling to top offset ${topOffset}`)
          setTimeout(() => window.scrollTo({ top: topOffset, behavior: 'auto' }), 200)
        }
      }
    }

    events.on('routeChangeComplete', handle)
    return () => {
      events.off('routeChangeComplete', handle)
    }
  }, [dispatch, events, topOffset, productsListId])

  /* TODO is mobile */

  const { newsletter = '0' } = customer ?? { newsletter: '0' }

  const isIndexPage = pathname === '/'
  const visibleHeaderAndFooter = !pathname.endsWith('/wishlist-print')
  const isPrint = isPrintMode()
  return (
    <CwsSection backgroundColor="white">
      <BreadCrumbsProvider>
        {!isClient && <IntegratedHeaderPreloaded />}
        {isClient && visibleHeaderAndFooter && <IntegratedHeader />}
        <main className={clsx(s.layoutContent)}>
          <CwsGrid width={isPrint && 'fluid'}>
            <CwsGridRow noGutter>
              {!isIndexPage && visibleHeaderAndFooter && <BreadCrumbs />}
              <CwsGridCol col="12">{children}</CwsGridCol>
              {visibleHeaderAndFooter && (
                <CwsGridCol>
                  <Subscription />
                </CwsGridCol>
              )}
            </CwsGridRow>
          </CwsGrid>
        </main>
      </BreadCrumbsProvider>
      {visibleHeaderAndFooter && <FooterComponent />}
    </CwsSection>
  )
}

export default Layout
